<template>
  <div>
        <v-text-field
          :id="`edit-event-title-input-${lang}`"
          :label="$t('EVENTFORM.form.title')"
          :rules="[(v) => !!v || $t('EVENTFORM.form_validation.title')]"
          required
          outlined
          v-model="content.title"
        ></v-text-field>
        <TextBox
          :id="`edit-event-description-input-${lang}`"
          class="mb-8"
          ref="description"
          :title="$t('EVENTFORM.form.description')"
          @updateHtml="content.description = $event"
          @mounted="setDescriptionText()"
        />
  </div>
</template>

<script>
import TextBox from '@/components/atoms/TextBox.vue';
export default {
  props: ["content", "lang"],
  components: {
    TextBox
  },
  methods: {
    setDescriptionText() {
      this.$refs.description.setContent(this.content.description || '');
    }
  }
};
</script>